import { useEffect, useState } from "react";
// import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import SEO from "components/headers/Seo";
import { Link } from "react-router-dom";

export default function TermsConditions({ configImages, branch }) {
  const [banner, setBanner] = useState("");
  const name = "SIBIRAJA NAGAI MAALIGAI LLP";
  const Site_Url = "https://vclive.prod-rasiinfotech";

  useEffect(() => {
    configImages?.E_COMMERCE_BANNERS?.forEach((d) => {
      if (d.key === "termsConditions") setBanner(d.value);
    });
  }, []); // eslint-disable-line

  const sections = [
    { title: `Greetings from ${name}`, body: `We value what you value. For us, jewels carry more than physical value. ${name} always anchors this principle in its value system and takes utmost care in honoring that. Please read carefully about our company's terms.` },
    { title: "Owned and Operated By", body: `The website is owned and operated by ${name} having its registered office at ${branch?.branchAddress ? branch.branchAddress.address1 + (branch.branchAddress.address2 || "") : ""}.` },
    { title: "User Agreement", body: `${name} policies are rules and guidelines that create and promote a safe and fair trading environment. All users are responsible for understanding and abiding by these policies and all applicable laws.` },
    { title: "Eligibility Criteria", body: `Any user deemed 'incompetent to contract' under the Indian Contract Act, 1872 is not eligible to use this website. Anyone below 18 years of age shall not be allowed to become a member or purchase through this website.` },
    { title: "Registration", body: `Registration with ${Site_Url} is simple, easy and free. Users must provide true, accurate and current information. ${name} reserves the right to suspend accounts where inaccurate information is suspected.` },
    { title: "Contact & Personal Information", body: `Users must enter personal information including Name, Address and Phone number. Date of Birth is used to verify age. Users may update personal information in their profile at any time and are advised not to share login credentials.` },
    { title: "Tax and Value Added Charges", body: `As per current Government of India regulations, all jewels — Gold, Silver, Diamond, Platinum, or any precious metal — are subject to GST. The cost of jewels includes physical content, designing cost, making charges and wastages.` },
    { title: "Termination of Agreement", body: `${name} reserves the right to terminate memberships when members violate terms and conditions or privacy policy, without prior notice. Members must erase downloaded data upon termination. Outstanding payments remain due after termination.` },
    { title: "Disclaimer", body: `${name} does not warrant that the website will be uninterrupted, error-free, or free of viruses. ${name} will not be liable for any loss or damage arising from use of the website or inability to use it.` },
    { title: "Governing Law", body: `The user agreement shall be governed by and construed in accordance with the laws of India. Any disputes shall be subject to the exclusive jurisdiction of the courts in Salem, Tamil Nadu.` },
  ];

  return (
    <div style={{ background: "#fff" }}>
      <SEO title={`Terms & Conditions — ${name}`} description="Terms and conditions of Sibiraja Nagai Maaligai LLP." name={name} type="article" />

      {/* Header */}
      {banner ? (
        <div style={{ position: "relative", overflow: "hidden", maxHeight: 200 }}>
          <img src={banner} alt="Terms" style={{ width: "100%", objectFit: "cover", maxHeight: 200, display: "block" }} />
          <div style={{ position: "absolute", inset: 0, background: "rgba(0,0,0,.45)", display: "flex", alignItems: "center", padding: "0 5%" }}>
            <h1 style={{ fontFamily: "var(--font-display)", fontSize: "clamp(28px,4vw,44px)", fontWeight: 500, color: "#fff", margin: 0 }}>Terms & Conditions</h1>
          </div>
        </div>
      ) : (
        <div style={{ background: "var(--surface-cream)", borderBottom: "1px solid var(--gold-200)", padding: "48px 0", textAlign: "center" }}>
          <p style={{ fontSize: 11, fontWeight: 700, letterSpacing: ".14em", textTransform: "uppercase", color: "var(--gold-500)", margin: "0 0 8px" }}>{name}</p>
          <h1 style={{ fontFamily: "var(--font-display)", fontSize: "clamp(28px,4vw,44px)", fontWeight: 500, color: "var(--ink-900)", margin: 0 }}>Terms & Conditions</h1>
        </div>
      )}

      <div className="container">
        <nav style={{ display: "flex", alignItems: "center", gap: 8, padding: "14px 0", fontSize: 13, color: "var(--ink-400)" }}>
          <Link to="/" style={{ color: "var(--ink-600)", textDecoration: "none" }}>Home</Link>
          <span>/</span>
          <span style={{ color: "var(--gold-500)", fontWeight: 500 }}>Terms & Conditions</span>
        </nav>
      </div>

      <div className="container" style={{ maxWidth: 820, paddingBottom: 80 }}>
        <p style={{ fontSize: 13, color: "var(--ink-600)", marginBottom: 36 }}>
          Last updated: {new Date().getFullYear()}. Please read these terms carefully before using our website.
        </p>

        {sections.map((s, i) => (
          <div key={i} style={{ marginBottom: 32, paddingBottom: 32, borderBottom: i < sections.length - 1 ? "1px solid var(--ink-100)" : "none" }}>
            <h3 style={{ fontFamily: "var(--font-body)", fontSize: 18, fontWeight: 500, color: "var(--gold-300)", marginBottom: 10 }}>
              {i + 1}. {s.title}
            </h3>
            <p style={{ fontSize: 14.5, lineHeight: 1.85, color: "var(--ink-900)", margin: 0 }}>{s.body}</p>
          </div>
        ))}
      </div>
    </div>
  );
}